import { render, staticRenderFns } from "./PoveznicaDataBase.vue?vue&type=template&id=134cc364&scoped=true&"
import script from "./PoveznicaDataBase.vue?vue&type=script&lang=js&"
export * from "./PoveznicaDataBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134cc364",
  null
  
)

export default component.exports